'use strict';function cback(data) {
  // "data" is the returned structure that contains the json.
  // NOTE: it came from jsonp, now "data" only contains json, as requested.
  // the rest of this method for example purposes only
  var resArr = [];
  $.each(data.results, function (indx, el) {
    if (typeof el !== 'undefined' && Object.hasOwnProperty('name')) {
      resArr.push(el.name);
    }
  });
  if (resArr.length > 0) {
    $('.gsa-input').autocomplete({ source: resArr });
  }
}

(function (w, doc, $) {
  // For testing the mock suggest.json file use:
  var suggestUrl = 'http://gweb.blackprivet.com:3000/suggest';
  // For using the production url add the correct host information and
  // path to the /suggest service.
  //var suggestUrl = '/suggest'
  /*******
  ** Other parameters include:
  ** callback : name of the callback. In my test, it is cback.
  ** client : default_frontend
  ** format : 'rich' is the type we are using in GSA.
  ** max : How many matches to show.
  *******/
  $(doc).ready(function () {
    var params = {
      callback: 'cback',
      format: 'rich',
      max: 10 };


    function makeSuggestReq(url) {
      $.ajax({
        url: url,
        dataType: 'jsonp' });

    }
    // Assemble parameters and url:
    var reqUrl = suggestUrl + '?' + $.param(params);
    var el = $('.gsa-input');
    // My test input box
    $('.gsa-input').keypress(function (event) {
      var query = el.val().trim();
      if (query.length >= 1) {
        makeSuggestReq(reqUrl + '&q=' + query);
      }
    });
  });
})(window, document, jQuery);
//# sourceMappingURL=gsa-query-autocomplete.js.map
